__turbopack_context__.v({
  "ant-dropdown-menu": "index-module-scss-module__GvXPJa__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__GvXPJa__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__GvXPJa__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__GvXPJa__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__GvXPJa__back-top-wrap",
  "confirm": "index-module-scss-module__GvXPJa__confirm",
  "filterTableSelect": "index-module-scss-module__GvXPJa__filterTableSelect",
  "popupBody": "index-module-scss-module__GvXPJa__popupBody",
  "popupHeader": "index-module-scss-module__GvXPJa__popupHeader",
});
